<template>
  <div class="MyOrder">
    <div class="add">
      <el-button type="primary" plain @click="handleToRepair()">
        新增维修申请
      </el-button>
    </div>
    <ul class="tagList">
      <li
        :class="{ selected: form_head_uuid === item.form_head_uuid }"
        v-for="(item, index) in tagList"
        :key="'tag' + index"
        @click="changeIndex(item.form_head_uuid)"
      >
        {{ item.name }}
      </li>
    </ul>
    <div class="orderBox" v-if="orderList && orderList.length > 0">
      <div class="orderTableHeader">
        <span>商品</span>
        <!-- <span>单价</span> -->
        <!-- <span>数量</span> -->
        <!-- <span>状态</span> -->
        <!-- <span>交易操作</span> -->
      </div>
      <ul class="orderList">
        <li v-for="item in orderList" :key="'order' + item.id">
          <div class="orderHeader">
            <span class="orderTime">{{ item.u6g7gjunacqjmudx }}</span>
            <span class="orderId">
              {{ '维修单编号：' + item['3pp6dg9j4ex79ook'] }}
            </span>
          </div>
          <div
            class="orderDetail"
            v-for="(order, idx) in item.children"
            :key="idx"
          >
            <img
              v-if="
                order['0ag6jxdaxesngyli'] &&
                order['0ag6jxdaxesngyli'].length > 0
              "
              :src="
                order['0ag6jxdaxesngyli'] &&
                order['0ag6jxdaxesngyli'].length > 0
                  ? order['0ag6jxdaxesngyli'][0].url
                  : ''
              "
              alt="商品图片"
            />
            <div class="goodsName">
              <p
                v-if="
                  order.com1x9fiqphdkau6 && order.com1x9fiqphdkau6.length > 0
                "
              >
                {{ order.com1x9fiqphdkau6[0].value }}
              </p>
            </div>
            <!-- <button
              v-if="
                item.qpfsvknudb8gbzee ===
                  'dcc22cc0-d69b-4dbe-ab01-e0680a7391dc' &&
                item['3u7sabpxxpxioiqz']
              "
            >
              确认邮寄
            </button>
            <button>重新提交</button> -->
          </div>
        </li>
      </ul>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 40, 80]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <p class="emptyTips" v-else>
      <img src="../../assets/img/order.svg" alt="" />
    </p>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Popup from "../../components/Popup";
import { online, children } from "@/api/platform";
import { otherSystemGetLoginToMeUrl } from "@/util/util";
export default {
  name: "MyOrder",
  components: {
    Popup,
  },
  computed: {
    ...mapState(["clientToken"]),
  },
  data () {
    return {
      tagList: [
        {
          name: "全部",
          form_head_uuid: "067434d8ae9311eea8aa0242321230b4",
        },
        { name: "审核中", form_head_uuid: "beaea547e2de4b1e8db0d1f443240e33" },
        {
          name: "审核成功",
          form_head_uuid: "da07ce01fcb34202ac26c0a9ac6256e3",
        },
        {
          name: "审核失败",
          form_head_uuid: "08656c93268a4802932daaac7078d63e",
        },
        {
          name: "已邮寄",
          form_head_uuid: "9b6e3eab457941c8beb6b46f0a62e206",
        },
        {
          name: "取件验收",
          form_head_uuid: "55a39a13a6074fd49f8fa08ecd312dfb",
        },
        {
          name: "维修中",
          form_head_uuid: "b9ba63c28830497c93a66c229a81e3b0",
        },
        {
          name: "总集已发货",
          form_head_uuid: "d6170e6130c34e89b1f5e25b53e67c75",
        },
        {
          name: "确认收货",
          form_head_uuid: "c93be1c16fc64fdab8177903e4314d0f",
        },
      ],
      form_head_uuid: "067434d8ae9311eea8aa0242321230b4",
      orderList: [],
      popupShow: false,
      curOrderId: "",
      curCommentGoodsId: "",
      curCommentGoodsDetailId: "",
      curStar: 0,
      hasClickStar: false,
      comment: "",
      //分页
      page: 1,
      total: 0,
      limit: 20,
    };
  },

  methods: {
    // 获取订单列表
    async getOrderList () {
      const { form_head_uuid, page, limit } = this;
      const { meta, result } = await online({
        form_head_uuid,
        page,
        limit,
        keyword: "",
        select_option: "",
      });
      let list = await Promise.all(
        result.map(async (el) => ({
          ...el,
          children: await this.children(el.id),
        }))
      );
      this.orderList = list;
      this.total = meta.total;
    },
    // 获取子表数据
    async children (record_id) {
      const { form_head_uuid } = this;
      const { result } = await children({
        page: 1,
        limit: 100,
        field_uuid: "49da24a35fde43bdb527817494ec8524",
        form_head_uuid,
        record_id,
      });
      return result;
    },
    // 切换页数
    handleCurrentChange (page) {
      this.page = page;
      this.getOrderList();
    },
    handleSizeChange (limit) {
      this.page = 1;
      this.limit = limit;
      this.getOrderList();
    },
    changeIndex (form_head_uuid) {
      this.page = 1;
      this.form_head_uuid = form_head_uuid;
      this.getOrderList();
      // this.getOrderByState(this.curIndex - 1);
    },
    navTo (route) {
      this.$router.push(route);
    },
    handleToRepair () {
      otherSystemGetLoginToMeUrl('b01a7096e59411ee8c5a0242ac150003', 'sg59YQ5afAL0wG45')
    },
  },

  mounted () {
    // this.getOrderByState(-1);
    this.getOrderList();
  },
};
</script>

<style scoped lang="less">
@import '../../assets/css/var.less';
.MyOrder {
  .tagList {
    li {
      text-align: center;
      display: inline-block;
      font-weight: 550;
      font-size: 18px;
      border-bottom: 2px solid @borderColor;
      cursor: pointer;
      padding: 10px 20px;
      position: relative;
      &:after {
        top: 12px;
        right: 0;
        position: absolute;
        content: '';
        width: 1px;
        height: 15px;
        background-color: @borderColor;
      }
      &:last-child {
        &:after {
          display: none;
        }
      }
    }
    .selected {
      color: @thirdColor;
      border-bottom: 2px solid @thirdColor;
    }
  }
  .orderBox {
    width: 100%;
    margin-top: 20px;
    .orderTableHeader {
      width: 100%;
      height: 40px;
      background-color: #f5f5f5;
      border: 1px solid @borderColor;
      color: @fontDefaultColor;
      font-size: 14px;
      line-height: 40px;
      display: flex;
      justify-content: flex-start;
      span {
        display: inline-block;
        width: 150px;
        line-height: 40px;
        text-align: center;
        &:first-child {
          width: 500px;
        }
      }
    }
    .orderList {
      width: 100%;
      li {
        border: 1px solid @borderColor;
        font-size: 13px;
        margin-top: 10px;
        .orderHeader {
          background-color: #f1f1f1;
          height: 40px;
          line-height: 40px;
          padding: 0 5px;
          .orderTime {
            font-weight: 600;
          }
          .orderId,
          .state {
            margin-left: 10px;
          }
          .deleteBtn {
            float: right;
            cursor: pointer;
            i {
            }
          }
        }
        .orderDetail {
          width: 100%;
          padding: 10px;
          position: relative;
          overflow: hidden;
          display: flex;
          justify-content: flex-start;
          img {
            width: 84px;
            height: 84px;
            display: inline-block;
          }
          .goodsName {
            display: inline-block;
            margin-left: 5px;
            width: 400px;
            vertical-align: top;
            p {
              cursor: pointer;
              line-height: 20px;
              &:hover {
                text-decoration: underline;
              }
            }
            span {
              color: @fontDefaultColor;
              display: block;
              margin-top: 10px;
            }
          }
          .unitPrice,
          .num,
          .amount,
          .hasComment {
            display: inline-block;
            vertical-align: top;
            width: 150px;
            height: 85px;
            line-height: 85px;
            text-align: center;
          }
          .status {
            position: absolute;
            right: 10px;
            img {
              width: 70px;
              opacity: 0.9;
            }
          }
          button {
            position: absolute;
            right: 90px;
            top: 50%;
            transform: translate(0, -50%);
            width: 70px;
            height: 30px;
            border-radius: 3px;
            background-color: @thirdColor;
            color: white;
            border: none;
          }
        }
      }
    }
    .pagination {
      display: flex;
      justify-content: flex-end;
      margin: 20px 0 0;
    }
  }
  .popupContent {
    padding: 10px;
    .scoreBox {
      width: 100%;
      height: 50px;
      position: relative;
      line-height: 50px;
      text-align: left;
      .tips {
        font-size: 15px;
        vertical-align: middle;
        display: inline-block;
      }
      i {
        cursor: pointer;
        vertical-align: middle;
        display: inline-block;
        font-size: 25px;
        margin-right: 5px;
        -webkit-text-stroke: 1px #f9bd4f;
      }
    }
    textarea {
      width: 400px;
      height: 80px;
      padding: 5px;
      border: 1px solid @borderColor;
      display: block;
      margin-top: 10px;
    }
    button {
      display: block;
      margin: 10px auto;
      width: 70px;
      height: 30px;
      border-radius: 3px;
      background-color: #313541;
      color: white;
      border: none;
    }
  }
}
.emptyTips {
  text-align: center;
  margin: 200px auto;
}
</style>


// WEBPACK FOOTER //
// src/pages/client/Repair.vue